import React from 'react';
import { CheckCircle } from 'lucide-react';
export function DifferentiatorSection() {
  return <section className="py-16 md:py-20 bg-[#FFF8F0]" data-id="element-51">
      <div className="max-w-5xl mx-auto px-4" data-id="element-52">
        {/* Differentiator */}
        <div className="mb-10 md:mb-14" data-id="element-53">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8 md:mb-10" data-id="element-54">
            🧠 ¿Qué hace diferente este MegaPack?
          </h2>
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-55">
            <div className="bg-pink-50 p-6 md:p-8 rounded-lg border border-pink-200" data-id="element-56">
              <h3 className="font-bold text-[#BE185D] mb-4 text-lg" data-id="element-57">
                ❌ Lo que NO es:
              </h3>
              <ul className="space-y-3" data-id="element-58">
                <li className="flex items-center text-[#9D174D]" data-id="element-59">
                  <span className="mr-2" data-id="element-60">❌</span> No es información suelta
                </li>
                <li className="flex items-center text-[#9D174D]" data-id="element-61">
                  <span className="mr-2" data-id="element-62">❌</span> No es teoría desordenada
                </li>
                <li className="flex items-center text-[#9D174D]" data-id="element-63">
                  <span className="mr-2" data-id="element-64">❌</span> No es "mirá videos y
                  arreglate"
                </li>
              </ul>
            </div>
            <div data-id="element-65">
              <h3 className="font-bold text-green-800 mb-4 text-lg" data-id="element-66">
                ✅ Lo que SÍ incluye cada tomo:
              </h3>
              <ul className="space-y-3" data-id="element-67">
                {['Fundamentos técnicos reales', 'Bioseguridad profesional', 'Protocolos paso a paso', 'Errores comunes', 'Atención al cliente', 'Cómo calcular precios', 'Cómo hacerlo rentable'].map((item, i) => <li key={i} className="flex items-center text-gray-700" data-id="element-68">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-2" data-id="element-69" />
                    {item}
                  </li>)}
              </ul>
              <p className="mt-6 font-bold text-gray-900 italic" data-id="element-70">
                Esto es estructura profesional, no entretenimiento.
              </p>
            </div>
          </div>
        </div>

        {/* Money Talk */}
        <div className="bg-[#FFF0F5] rounded-2xl p-6 md:p-12 border border-pink-100 text-center mb-10 md:mb-14" data-id="element-71">
          <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-4 md:mb-6" data-id="element-72">
            💰 Hablemos de dinero real
          </h2>
          <p className="text-base md:text-lg text-gray-600 mb-6 md:mb-8" data-id="element-73">
            En estética, los números son simples. Una sola sesión de:
          </p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mb-6 md:mb-8" data-id="element-74">
            <div className="bg-white p-3 md:p-4 rounded shadow-sm" data-id="element-75">
              <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-76">
                Extensiones
              </p>
              <p className="text-xs text-[#BE185D]" data-id="element-77">Servicio recurrente</p>
            </div>
            <div className="bg-white p-3 md:p-4 rounded shadow-sm" data-id="element-78">
              <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-79">
                Micropigmentación
              </p>
              <p className="text-xs text-[#BE185D]" data-id="element-80">Ticket alto</p>
            </div>
            <div className="bg-white p-3 md:p-4 rounded shadow-sm" data-id="element-81">
              <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-82">
                Manicuría
              </p>
              <p className="text-xs text-[#BE185D]" data-id="element-83">Clientes frecuentes</p>
            </div>
            <div className="bg-white p-3 md:p-4 rounded shadow-sm" data-id="element-84">
              <p className="font-bold text-gray-900 text-sm md:text-base" data-id="element-85">
                Depilación Láser
              </p>
              <p className="text-xs text-[#BE185D]" data-id="element-86">Paquetes de sesiones</p>
            </div>
          </div>

          <p className="text-lg md:text-xl font-medium text-gray-800" data-id="element-87">
            Con pocos clientes por semana, ya podés generar ingresos extra.{' '}
            <br data-id="element-88" />
            <span className="font-bold text-[#BE185D]" data-id="element-89">
              No es motivación. Es matemática.
            </span>
          </p>
        </div>

        {/* Objection Handling */}
        <div className="text-center max-w-3xl mx-auto" data-id="element-90">
          <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4" data-id="element-91">
            😰 "Pero yo nunca hice nada de esto..."
          </h3>
          <p className="text-xl font-bold text-green-600 mb-6" data-id="element-92">Perfecto.</p>
          <p className="text-gray-700 mb-8" data-id="element-93">
            El MegaPack fue creado exactamente para personas que empiezan desde
            cero, sin experiencia previa, que necesitan claridad, orden y
            aprender paso a paso.
          </p>
          <div className="bg-[#FFF0F5] border-l-4 border-pink-400 p-4 md:p-6 text-left" data-id="element-94">
            <p className="font-bold text-gray-900 mb-2" data-id="element-95">
              ⚠️ La verdadera pregunta es otra…
            </p>
            <p className="text-gray-700 italic" data-id="element-96">
              ¿Qué pasa si seguís igual? Si dentro de 6 meses siguen las
              cuentas, sigue el estrés, sigue la dependencia... Nada cambia si
              no cambiás nada.
            </p>
          </div>
        </div>
      </div>
    </section>;
}